import React from 'react';
import PropTypes from 'prop-types';

const DesktopActivePlane = ({ className, color }) => (
  <svg
    className={className}
    width='28px'
    height='26px'
    viewBox='0 0 28 26'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Desktop-2' transform='translate(-205.000000, -209.000000)' fill='#FFFFFF'>
        <g id='Group-11' transform='translate(173.000000, 191.000000)'>
          <path
            d='M60.5336504,31.6547404 L49.2494399,24.476169 L49.2494399,16.5797404 C49.2494399,15.3880976 48.3043873,14.426169 47.1336504,14.426169 C45.9629136,14.426169 45.017861,15.3880976 45.017861,16.5797404 L45.017861,24.476169 L33.7336504,31.6547404 L33.7336504,34.526169 L45.017861,30.9368833 L45.017861,38.8333118 L42.1968083,40.9868833 L42.1968083,43.1404547 L47.1336504,41.7047404 L52.0704925,43.1404547 L52.0704925,40.9868833 L49.2494399,38.8333118 L49.2494399,30.9368833 L60.5336504,34.526169 L60.5336504,31.6547404 Z'
            id='active-airplane'
            transform='translate(47.133650, 28.783312) rotate(-300.000000) translate(-47.133650, -28.783312) '
          />
        </g>
      </g>
    </g>
  </svg>
);

DesktopActivePlane.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default DesktopActivePlane;



// WEBPACK FOOTER //
// ./src/icons/DesktopActivePlane.js